import { NormalizedDropdownItemType, SearchableDropdown } from '@entur/dropdown'
import React, { useState } from 'react'
import { StopPlace } from '../../../api-clients/api-types'
import { getStopPlaceRegister } from '../../../api-clients/eba-clients'
import { DropdownItemType } from '../../form/dropdowns'
import './stop-places.scss'

const mapToDropdownItem = (stopPlace: StopPlace): DropdownItemType => {
  return {
    value: stopPlace.properties.id,
    label: stopPlace.properties.name,
  }
}

type StopPlacesDropdownProps = {
  label: string
  onChange: (selectedItem: string) => void
}
export const StopPlacesDropdown: React.FC<StopPlacesDropdownProps> = (props) => {
  const [selectedItem, setSelectedItem] = useState<NormalizedDropdownItemType<string> | null>(null)

  const fetchItems = async (query?: string) => {
    if (!query) {
      return []
    }
    return getStopPlaceRegister({ id: query }).then((stopPlaces) => stopPlaces.features.flatMap(mapToDropdownItem))
  }

  return (
    <SearchableDropdown<string>
      className="stopPlaces"
      selectOnTab={true}
      label={props.label}
      items={fetchItems}
      selectedItem={selectedItem}
      onChange={(e) => {
        setSelectedItem(e)
        props.onChange(e?.value || '')
      }}
    />
  )
}
